import React from 'react';

const qas = [
  { q: 'Next Quarter Implications', a: 'Expect continued sequential growth driven by data center demand.' },
  { q: 'Next 12 Months Implications', desc: 'Longer-term outlook and structural trends to monitor...', a: '' },
  { q: 'Guidance Risk', desc: 'Assess downside risk to forward guidance.', a: '' },
];

const Preview: React.FC = () => (
  <div className="h-full bg-surface p-4 flex flex-col">
    <div className="flex-1 space-y-4 overflow-hidden">
      {qas.map((item, i) => (
        <div key={i}>
          <p className="text-xs font-bold text-neutral-800 mb-1">{item.q}</p>
          {item.desc && (
            <p className="text-[10px] text-neutral-400 mb-1">{item.desc}</p>
          )}
          <div className="px-3 py-2 rounded-md border border-neutral-600 bg-surface-secondary">
            <span className="text-[10px] text-neutral-500">
              {item.a || 'Enter your answer...'}
            </span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Preview;
